const KEY = 'org-frontend';

type ParticipantsPage = {
  filter: any;
  selectedColumns: string[]
};

type RegistrationPage = {
  filter: any;
  selectedColumns: string[]
}

type CalendarPage = {
  filter: any
}

type Store = {
  participants?: ParticipantsPage;
  registration?: RegistrationPage;
  calendar?: CalendarPage
};

export const getData = () => {
  const data = sessionStorage.getItem(KEY);

  return JSON.parse(data || '{}') as Store;
};

export const store = async (store: Store) => {
  sessionStorage.setItem(KEY, JSON.stringify({ ...getData(), ...store }));
};

export const storeParticipantsPage = async (participants: ParticipantsPage) => {
  store({ participants });
};

export const storeRegistrationPage = async (registration: RegistrationPage) => {
  store({ registration });
};

export const storeCalendarPage = async (calendar: CalendarPage) => {
  store({ calendar });
};
